import { useTranslation } from 'react-i18next';
import { siteConfig } from '../siteConfig';

export function Program() {
  const { t } = useTranslation();
  return (
    <section id={siteConfig.sections.program.anchor} className="section">
      <h2 className="section-title">{t('program.title')}</h2>
      <p className="section-subtitle">{t('program.subtitle')}</p>
      <div className="tba">{t('program.tba')}</div>
    </section>
  );
}
